const initialState = {
	isComputingDiffs: undefined,
	errors: undefined,
	processingMessages: undefined
};

export default initialState;
